import script from "./MarcasXProductoView.vue?vue&type=script&setup=true&lang=js"
export * from "./MarcasXProductoView.vue?vue&type=script&setup=true&lang=js"

import "./MarcasXProductoView.vue?vue&type=style&index=0&id=4c921b09&lang=css"

const __exports__ = script;

export default __exports__